function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.9 1.29999H3.10001C2.90001 1.29999 2.70001 1.49999 2.70001 1.69999V26.6C2.70001 26.8 2.90001 27 3.10001 27H5.40001V28.6C5.40001 29.1 5.80001 29.5 6.30001 29.5H8.90001C9.40001 29.5 9.80001 29.1 9.80001 28.6V27H22V28.6C22 29.1 22.4 29.5 22.9 29.5H25.5C26 29.5 26.4 29.1 26.4 28.6V27H28C28.2 27 28.4 26.8 28.4 26.6V1.79999C28.4 1.49999 28.2 1.29999 27.9 1.29999ZM8.80001 28.8H6.20001V27.2H8.80001V28.8ZM25.5 28.8H22.9V27.2H25.5V28.8ZM27.5 26.2H3.50001V2.19999H27.5V26.2Z",
  fill: "#1C33C8"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.99999 23.9H25C25.1 23.9 25.2 23.8 25.2 23.7V4.7C25.2 4.6 25.1 4.5 25 4.5H5.99999C5.89999 4.5 5.79999 4.6 5.79999 4.7V23.7C5.79999 23.8 5.89999 23.9 5.99999 23.9ZM6.29999 5H24.8V23.5H6.29999V5Z",
  fill: "#1C33C8"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.5 8.89999C14 8.89999 12.7 10.2 12.7 11.7C12.7 12.8 13.4 13.8 14.4 14.2V19.2C14.4 19.3 14.5 19.4 14.6 19.4H16.3C16.4 19.4 16.5 19.3 16.5 19.2V14.2C17.5 13.8 18.2 12.8 18.2 11.7C18.3 10.2 17 8.89999 15.5 8.89999ZM16.3 13.9C16.2 13.9 16.1 14 16.1 14.1V19.1H14.9V14.1C14.9 14 14.8 13.9 14.7 13.9C13.8 13.6 13.1 12.7 13.1 11.7C13.1 10.4 14.2 9.39999 15.4 9.39999C16.6 9.39999 17.7 10.5 17.7 11.7C17.8 12.7 17.2 13.6 16.3 13.9Z",
  fill: "#1C33C8"
});

var SvgSicher = function SvgSicher(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSicher, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sicher.35d51203.svg";
export { ForwardRef as ReactComponent };